import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { PlainContentModuleContainer, TextContentBlock, TextContentBlockWithFigures, TextContentBlockWithIcons } from "@silvertours/front-entities";
import { Ui } from "@silvertours/front-shared";
export var Destination = function(props) {
    var icons = props.icons, translations = props.translations, providers = props.providers, rules = props.rules;
    if (icons === null || icons === void 0 ? void 0 : icons.length) {
        return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
            children: /*#__PURE__*/ _jsx(TextContentBlockWithIcons, {
                content: _object_spread_props(_object_spread({}, props), {
                    icons: icons
                }),
                rules: rules
            })
        });
    }
    if (providers === null || providers === void 0 ? void 0 : providers.length) {
        var ref = translations || {}, _providerPositionLabel = ref.providerPositionLabel, providerPositionLabel = _providerPositionLabel === void 0 ? "" : _providerPositionLabel;
        return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
            children: /*#__PURE__*/ _jsx(TextContentBlockWithFigures, {
                content: _object_spread_props(_object_spread({}, props), {
                    figures: providers.map(function(provider, index) {
                        return _object_spread_props(_object_spread({}, provider), {
                            position: index + 1
                        });
                    }),
                    positionLabel: providerPositionLabel
                }),
                rules: rules
            })
        });
    }
    return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(TextContentBlock, {
            content: props,
            rules: _object_spread_props(_object_spread({}, rules), {
                isContainerMultiColumn: false,
                textStyle: {
                    style: (rules === null || rules === void 0 ? void 0 : rules.textStyle) || Ui.RichTextStyle.Primary
                }
            })
        })
    });
};
